import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	label: {
		id: 'app.packRowList.label',
		defaultMessage: 'Content row for {title}',
		description: 'Screen reader label for a playlist row item',
	},
	playAriaLabel: {
		id: 'app.packRowList.playlistHeader.playAriaLabel',
		defaultMessage: 'Play {title}',
		description: 'Screen reader label for the playlist header play button',
	},
	shuffleAriaLabel: {
		id: 'app.packRowList.playlistHeader.shuffleAriaLabel',
		defaultMessage: 'Shuffle play {title}',
		description: 'Screen reader label for the playlist header shuffle button',
	},
	curatorAriaLabel: {
		id: 'app.packRowList.playlistHeader.curatorAriaLabel',
		defaultMessage: "View {curator}'s page",
		description: 'Screen reader label for the playlist header curator attribution link',
	},
	playLabel: {
		id: 'app.packRowList.playlistHeader.playLabel',
		defaultMessage: 'Play',
		description: 'Visible label for the playlist header play button',
	},
	shuffleLabel: {
		id: 'app.packRowList.playlistHeader.shuffleLabel',
		defaultMessage: 'Shuffle',
		description: 'Visible label for the playlist header shuffle button',
	},
	trackSummary: {
		id: 'app.packRowList.playlistHeader.trackSummary',
		defaultMessage: '{count, plural, one {# track} other {# tracks}}, {duration}',
		description:
			'Track count and total duration summary shown under a playlist header title, matching mobile\'s separator, e.g. "11 tracks, 5 hr 47 min"',
	},
});
